export default "__VITE_PUBLIC_ASSET__222afb33__"